<template>
  <div class="pannel1">
    <NavBar class="scs" />
    <!-- 视频-->
    <div class="pannel1-descrip">
     <video
       poster="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/poster-mdj.png"
       id="myVideo"
       autoplay="autoplay"
       loop="loop"
       muted="muted"
       x5-video-player-type="h5"
       playsinline
       webkit-playsinline
       controlsList="nodownload"
       height="100%"
       width="100%"
       class="cs"
       style="object-fit: cover"
       ref="videoPlay"
     >
      <source src="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/media.io.mp4" type="video/mp4">
      您的浏览器不支持HTML5视频
     </video>
      <!--  -->
      <!-- <video
        poster="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/mdj-poster.png"
        id="video"
        src="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/media.io.mp4"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
        x5-video-player-type="h5"
        playsinline
        webkit-playsinline
        controlsList="nodownload"
        height="100%"
        width="100%"
        class="cs"
        style="object-fit: cover"
        ref="videoPlay"
        v-else
      ></video> -->
      <!--  <video
        poster="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/media-poster.png"
        src="https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/video/media.io.mp4"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
        controls="controls"
        controlsList="nodownload"
        height="100%"
        width="100%"
        class="cs"
        style=" object-fit:fill;"
        ref="videoPlay"
        v-else
      ></video> -->
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
export default {
  name: "Home",
  components: {
    NavBar,
  },
  data() {
    return {
      flagios: true,
    };
  },
 methods:{
   autoPlayVideo(){
     console.log('autoPlayVideo')
     this.videoInBrowserHandler();
     document.body.addEventListener('touchstart', this.videoInBrowserHandler);
     this.videoInWeixinHandler();
     document.addEventListener('DOMContentLoaded', this.videoInWeixinHandler);
   },
   videoInBrowserHandler(){
     	/* 自动播放视频效果，解决浏览器或  者APP自动播放问题 */
     this.videoPlay(true);
     document.body.removeEventListener('touchstart', this.videoInBrowserHandler);
     console.log('videoInBrowserHandler')
   },
   videoInWeixinHandler(){
     	/* 自动播放视频效果，解决微信自动播放问题 */
     console.log('videoInWeixinHandler')
     this.videoPlay(true);
     document.addEventListener("WeixinJSBridgeReady", function () {
       // this.videoPlay(true);
       myVideo.play()
     }, false);
     document.removeEventListener('DOMContentLoaded', this.videoInWeixinHandler);
   },
   videoPlay(isPlay){
     var media = document.getElementById('myVideo');
     console.log(media,'222')
     if (isPlay && media.paused) {
     	media.play();
     }
     if (!isPlay && !media.paused) {
     	media.pause();
     }
   }
 },
  mounted() {
    this.autoPlayVideo()
    // const u = navigator.userAgent,
    //   app = navigator.appVersion;
    // //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // if (isiOS) {
    //   console.log("ios");
    //   this.$refs.videoPlay.play();
    //   video.play();
    //   this.flagios = true;
    // } else {
    //   this.$refs.videoPlay.play();
    //   video.play();
    //   this.flagios = false;
    //   // alert('andriod');
    //   console.log('andriod')
    // }
    //  console.log('andriod000')
    // document.addEventListener(
    //   "WeixinJSBridgeReady",
    //   function () {
    //     video.play();
    //   },
    //   false
    // );
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  // pc
  //所有控件
  video::-webkit-media-controls-enclosure {
    display: none;
  }
  .pannel1 {
    width: 100%;
    height: 100vh;
    .scs {
      position: absolute;
      top: 0;
      z-index: 99;
    }
    .pannel1-descrip {
      width: 100%;
      height: 100vh;
      background: rgb(245, 242, 245);
      .cs {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  // mobile
  .pannel1 {
    width: 100%;
    height: 406px;
    // height:100vh;
    // background: #67AE73;
    .pannel1-descrip {
      width: 100%;
      height: 406px;
      background: #f5f2f5;

      .cs {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        // height: 25.375rem;
        height: 406px;
      }
    }
  }
}
.pannel1 {
  .pannel1-descrip {
    color: #fff;
  }
}
</style>
